import { render } from "./FormDefaultStepTwo.vue?vue&type=template&id=92159952&scoped=true"
import script from "./FormDefaultStepTwo.vue?vue&type=script&lang=js"
export * from "./FormDefaultStepTwo.vue?vue&type=script&lang=js"

import "./FormDefaultStepTwo.vue?vue&type=style&index=0&id=92159952&scoped=true&lang=css"

import exportComponent from "/home/runner/work/leadsbroker-anketa/leadsbroker-anketa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92159952"]])

export default __exports__